import { render } from "./RoomPlan.vue?vue&type=template&id=c53d6c5e&scoped=true"
import script from "./RoomPlan.vue?vue&type=script&lang=js"
export * from "./RoomPlan.vue?vue&type=script&lang=js"

import "./RoomPlan.vue?vue&type=style&index=0&id=c53d6c5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53d6c5e"]])

export default __exports__